
export enum UpdateStatus {
  REQUIRED = 'REQUIRED',
  ADVISED = 'ADVISED',
  UP_TO_DATE = 'UP_TO_DATE'
}
